/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useCallback, useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {toDate} from '../../../../common/utils/date';
import {defaultValues} from '../../../../data/constants/Assurance/assuranceRetraite';
import {thousandSeparator} from '../../../../data/factory';
import {IError} from '../../../../data/types/interface/Assurance/assuranceRetraite';
import {StackParams} from '../../../../data/types/navigation';
import {retraiteService} from '../../../../services/applicatif/retraite';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {Header} from '../../../components/Header/HeaderSouscriptionRetraite';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../components/PageContainer';
import {Form} from './Forms/FormWeb';

type NavigationProps = StackNavigationProp<
  StackParams,
  'SouscriptionAssuranceRetraiteForm'
>;

const dataws = {
  ...defaultValues,
};

const FSouscriptionAssuranceRetraiteForm = (props: any) => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const [listAgence, setListAgence] = useState([]);
  const [dataDto, setDataDto] = useState(dataws);
  const [postSucces, setPostSuccess] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const {getAgence, user, contratEnCoursUser} = props;
  let fromSimulation = false;
  const userId =
    user && user.data && user.data.utilisateur && user.data.utilisateur.id;

  const {dateNaissance, premierVersement} = props.route && props.route.params;
  if (dateNaissance) {
    fromSimulation = true;
  }

  const updateData = (user: any) => {
    dataDto.nomPrenomContractant = `${user.nom} ${user.prenom}`;
    dataDto.telephoneContractant = user.telephone;
    dataDto.telephoneContractantCountryCode = user.countryCode;
    dataDto.dateNaissanceContractant = user.dateNaissance;
    dataDto.dateNaissanceAssure = dateNaissance ? new Date(dateNaissance) : '';
    dataDto.premierVersement =
      premierVersement && thousandSeparator(premierVersement, '');
    dataDto.telephoneAssureCountryCode = 'MG';

    return dataDto;
  };

  useEffect(() => {
    if (user && user.data && user.data.utilisateur) {
      const _data = updateData(user.data.utilisateur);
      setDataDto(_data);
    }
  }, [user]);

  const mapAgence = useCallback((list: any) => {
    list = list.map((e: any) => {
      return {
        value: e.nom,
        label: e.nom,
      };
    });
    return list;
  }, []);

  useEffect(() => {
    setIsLoading(true);
    getAgence({}, (res: any) => {
      if (res && !res.isError && res.data && res.data.items) {
        const _list = mapAgence(res.data.items);
        setListAgence(_list);
      }
      setIsLoading(false);
    });
  }, []);

  const handleCancel = () => {
    goBack();
  };

  const handleSubmit = (res: any) => {
    setIsLoading(true);
    const _cinContractant = [];
    const _cinAssure = [];
    const _data = {...res};
    const _res = res;
    res = formDataDTO(res, 'simulation', '', userId);
    retraiteService()
      .souscrire(res)
      .then((res: any) => {
        if (res && !res.isError && res.data) {
          _cinContractant.push(_res.cinContractant);
          _cinAssure.push(_res.cinAssure);
          _data.dateNaissanceContractant = toDate(
            _res.dateNaissanceContractant,
          );
          _data.dateNaissanceAssure = toDate(_res.dateNaissanceAssure);

          setDataDto(_data);
          contratEnCoursUser({
            typeContrat: 'retraite',
            typePayment: 'souscription',
            formData: formDataDTO(_res, 'create', res.data.data, userId),
            premierVersement: _data.premierVersement,
            simulationId: res.data.data,
          });
          setPostSuccess(true);
        } else {
          setErrorMessage(res.message);
          setShowErrorModal(true);
        }
        setIsLoading(false);
      });
  };

  const formDataDTO = useCallback(
    (
      data: IError,
      operationType: string,
      simulationId: string,
      utilisateur: string,
    ) => {
      const formData = new FormData();

      data.cinAssure.length > 0 &&
        data.cinAssure.forEach((elt: any) => {
          formData.append('cinAssure', elt);
        });

      data.cinContractant.length > 0 &&
        data.cinContractant.forEach((elt: any) => {
          formData.append('cinContractant', elt);
        });

      formData.append('nomPrenomContractant', data.nomPrenomContractant);
      formData.append(
        'dateNaissanceContractant',
        data.dateNaissanceContractant,
      );
      formData.append('telephoneContractant', data.telephoneContractant);
      formData.append('nomPrenomAssure', data.nomPrenomAssure);
      formData.append('dateNaissanceAssure', data.dateNaissanceAssure);
      formData.append('adresseAssure', data.adresseAssure);
      formData.append('telephoneAssure', data.telephoneAssure);
      formData.append('emailAssure', data.emailAssure);
      formData.append('agence', data.agence);
      formData.append('premierVersement', data.premierVersement);
      formData.append('beneficiaireCasDeces', data.beneficiaireCasDeces);
      formData.append('operationType', operationType);
      formData.append('simulationId', simulationId);
      formData.append('utilisateur', utilisateur);
      formData.append('countryCodeAssure', data.telephoneAssureCountryCode);

      return formData;
    },
    [],
  );

  const redirectToPayment = useCallback(() => {
    setPostSuccess(false);
    navigate('Payement');
  }, []);

  return (
    <View>
      <HeaderScreen title="Souscription" type="retour" noBreadcrumb={false} />
      <PageContainer>
        {postSucces && (
          <ConfirmationModal
            title="Assurance Retraite"
            content="Pour finaliser votre souscription, veuillez procéder au paiement."
            btn1="OK"
            handleBtn1={redirectToPayment}
          />
        )}
        {/** Error modal */}
        {showErrorModal && (
          <ConfirmationModal
            title=""
            content={errorMessage}
            btn1="OK"
            handleBtn1={() => setShowErrorModal(false)}
          />
        )}
        {/** Loading */}
        {IsLoading && <Loader />}
        {/** Header content */}
        {!IsLoading && !postSucces && !showErrorModal && <Header />}
        {/** Form content */}
        {!postSucces && !IsLoading && !showErrorModal && (
          <Form
            data={dataDto}
            fromSimulation={fromSimulation}
            listAgence={listAgence}
            onCancelForm={handleCancel}
            onSubmitForm={handleSubmit}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const SouscriptionAssuranceRetraite = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FSouscriptionAssuranceRetraiteForm);
